import React from 'react';
import { Spinner } from 'react-bootstrap';
import styles from '../../../styles/TryNow.module.css';
import TypingResponse from '../../typingResponse/TypingResponse';
import img from '../../../assets/images/icons/1.png';
import ImagePreview from '../../imagePreview/ImagePreview';
import DynamicResultRenderer from './DynamicResultRenderer';
import { FEATURE_FLAGS } from '../../../common/config/featureFlags';
import { TRY_MODE } from '../../../common/Utils/Utils';

/*
 * ResultSection Component:
 * - Handles the display of results based on API response.
 * - `apiResponse`: Contains the result data from the API (current backend format).
 * - `previewResponseImage`: Determines whether to use legacy image preview or dynamic rendering.
 * - `selectedFile`: Holds the uploaded file details (image or PDF).
 *
 * RENDERING LOGIC (Priority Order):
 * 1. FUTURE: If ENABLE_NEW_RESPONSE_STRUCTURE=true && apiResponse.data exists → Use DynamicResultRenderer
 * 2. CURRENT: If previewResponseImage && apiResponse.detail.response_image → Show ImagePreview
 * 3. CURRENT: Else → Show TypingResponse (JSON viewer)
 *
 * NOTE: DynamicResultRenderer will only activate when:
 * - ENABLE_NEW_RESPONSE_STRUCTURE feature flag is true
 * - Backend returns new structure: { "data": { ...fields..., "documents": [...] } }
 */
const ResultSection = ({
  isProcessing,
  apiResponse,
  previewResponseImage,
  selectedFile,
  mode = TRY_MODE.SINGLE,
}) => (
  <div className="resultSection">
    {isProcessing ? (
      <div
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        className={styles.noResult}
      >
        <h5 className={styles.resultTitle}>Processing Results</h5>
        <Spinner
          animation="border"
          role="status"
          className={styles.loadingSpinner}
        />
        <p>Processing your image...</p>
      </div>
    ) : apiResponse ? (
      //Check for new backend response structure (enabled by feature flag)
      FEATURE_FLAGS.ENABLE_NEW_RESPONSE_STRUCTURE && apiResponse?.data ? (
        <DynamicResultRenderer
          apiResponse={apiResponse}
          selectedFile={selectedFile}
          mode={mode}
        />
      ) : // CURRENT: Legacy structure handling (existing backend)
      apiResponse?.detail?.response_image ? (
        <ImagePreview imageData={apiResponse} selectedFile={selectedFile} />
      ) : (
        <TypingResponse data={apiResponse} />
      )
    ) : (
      <div
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        className={styles.noResult}
      >
        <div className="resultIconBox d-flex justify-content-center align-items-center rounded-circle">
          <img className="w_30x h_30x object-fit-contain" src={img} alt="" />
        </div>
        <h3 className="font_18 font_500">Nothing to show!</h3>
        <p className="text-center mb-0">Upload an image to see the results</p>
      </div>
    )}
  </div>
);

export default ResultSection;
